export const RouteName = {
  main: "report-builder",
} as const;
